module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/wood-2-58fffc8b29f7471945db28799b6a9438.svg";